import { render, staticRenderFns } from "./ChatWithWR1.vue?vue&type=template&id=e2817e56"
import script from "./ChatWithWR1.vue?vue&type=script&lang=js"
export * from "./ChatWithWR1.vue?vue&type=script&lang=js"
import style0 from "./ChatWithWR1.vue?vue&type=style&index=0&id=e2817e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports